import constants from '../constants'

export const fetchObjectsToCache = (usedObjects: string[]) => {
    return ({
        type: constants.PROMISE_UPDATE_CACHE,
        payload: fetch(`${window.appContext}/proxy/alfresco/api/forms/picker/items`, {
            credentials: 'same-origin',
            method: 'POST',
            body: JSON.stringify({
                itemValueType: 'nodeRef',
                items: [...new Set(usedObjects)],
            }),
            headers: {
                [window.Alfresco.util.CSRFPolicy.getHeader()]: window.Alfresco.util.CSRFPolicy.getToken(),
                'Content-Type': 'application/json',
            },
        })
            .then(response => {
                if (response.status !== 200) {
                    throw response.json();
                }
                return response.json();
            }).then((responseJSON) => {
                return { ...Object.fromEntries(responseJSON.data.items.map((it: any) => [it.nodeRef, it])) };
            }
            )
    });
}
